import { makeStyles } from "@mui/styles";
import color from "@definitions/mui/color";

const useStyles = makeStyles(() => ({
    root: {
      border: `1px solid #DEE3ED`,
      "&:before": {
        display: "none",
      },
      borderRadius: "5px",
    },
    dropdownIcon: {
      color: color.general.main
    }
  }));

export default useStyles;
